.root {
  display: flex;
  color: var(--muted-old);

  svg {
    margin-right: 0.35rem;
  }
}

.source {
  display: inline-block;
  vertical-align: middle;
  color: var(--muted-old);
  transform: translateY(1px);
}
